import React, { useContext } from 'react'

interface ContextProps {
  blockAutoScroll: boolean
  setBlockAutoScroll: (newBlockAutoScroll: boolean) => void
}

const BlockAutoScrollContext = React.createContext<ContextProps | null | undefined>(null)

export const BlockAutoScrollProvider = ({
  value,
  children,
}: {
  value: ContextProps
  children: React.ReactNode
}) => <BlockAutoScrollContext.Provider value={value}>{children}</BlockAutoScrollContext.Provider>

export const useBlockAutoScroll = () => {
  const blockAutoScroll = useContext(BlockAutoScrollContext)

  if (!blockAutoScroll) {
    throw new Error('useBlockAutoScroll must be used within a Provider')
  }

  return blockAutoScroll
}
